import { connect } from 'react-redux';

import { getOrganizationMembersList } from '../../Projects/projectsActions';
import {
  clearMasterTaskState,
  clearTaskState,
  clearLinkTaskState,
  clearNewTaskState,
  clearMaxTaskTimeState,
  createMasterTask,
  createLinkTask,
  createMaxTaskDuration,
  getMasterTask,
  getNewTasks,
  getTaskDetails,
  getTaskType,
  getMaxTaskDuration,
  updateMasterTask,
  archiveMasterTask,
  unarchiveMasterTask,
} from '../tasksActions';
import MasterTask from './MasterTask';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  taskTypeIsLoading: state.task.taskTypeIsLoading,
  taskTypeList: state.task.taskTypeList,
  isMasterTaskLoading: state.task.isMasterTaskLoading,
  MasterTasks: state.task.MasterTasks,
  isCreateMasterTaskLoading: state.task.isCreateMasterTaskLoading,
  createdMasterTaskInfo: state.task.createdMasterTaskInfo,
  isUpdateMasterTaskLoading: state.task.isUpdateMasterTaskLoading,
  updatedMasterTaskInfo: state.task.updatedMasterTaskInfo,
  isArchiveMasterTaskLoading: state.task.isArchiving,
  archivedMasterTaskInfo: state.task.archivedMasterTaskInfo,
  isNewTaskLoading: state.task.isNewTaskLoading,
  NewTasks: state.task.NewTasks,
  isLinkMasterTaskLoading: state.task.isLinkMasterTaskLoading,
  createdLinkTaskInfo: state.task.createdLinkTaskInfo,
  isMaxTaskDurationLoading: state.task.isMaxTaskDurationLoading,
  maxTaskDurationInfo: state.task.maxTaskDurationInfo,
  fetchedMaxTaskDuration: state.task.fetchedMaxTaskDuration,
  isUnarchiveMasterTaskLoading: state.task.isUnarchiving,
  unarchiveMasterTaskInfo: state.task.unarchivedMasterTaskInfo
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getOrganizationMembersList: params =>
    dispatch(getOrganizationMembersList(params)),
  getTaskDetails: params => dispatch(getTaskDetails(params)),
  getTaskType: params => dispatch(getTaskType(params)),
  createMasterTask: params => dispatch(createMasterTask(params)),
  updateMasterTask: params => dispatch(updateMasterTask(params)),
  archiveMasterTask: params => dispatch(archiveMasterTask(params)),
  createLinkTask: params => dispatch(createLinkTask(params)),
  createMaxTaskDuration: params => dispatch(createMaxTaskDuration(params)),
  getMaxTaskDuration: () => dispatch(getMaxTaskDuration()),
  clearTaskState: () => dispatch(clearTaskState()),
  getMasterTask: params => dispatch(getMasterTask(params)),
  getNewTasks: params => dispatch(getNewTasks(params)),
  clearMasterTaskState: () => dispatch(clearMasterTaskState()),
  clearNewTaskState: () => dispatch(clearNewTaskState()),
  clearLinkTaskState: () => dispatch(clearLinkTaskState()),
  clearMaxTaskTimeState: () => dispatch(clearMaxTaskTimeState()),
  unarchiveMasterTask: params => dispatch(unarchiveMasterTask(params)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(MasterTask);
